import React from 'react';
import WorksBg from 'assets/works-bg.png';

import HomeScreenLeftImg from 'assets/home-screen.png';
import SendMoneyImg from 'assets/register2.png';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export const HowItWorks = () => {
  return (
    <div className="w-full py-12 md:px-6 ">
      <div className="mx-auto text-center">
        {/* Header */}
        <h2 className="text-3xl md:text-5xl font-bold mb-4">How It Works</h2>
        <p className="text-xl text-gray-600 mb-12">Simple, Hassle-Free Transfers in 2 Easy Steps</p>
      </div>

      {/* Carousel Section */}
      <div className="mx-auto">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          showStatus={false}
          interval={5000}
          className="rounded-3xl overflow-hidden"
        >
          {/* Carousel Item */}
          <div
            className="flex flex-col md:flex-row items-center justify-between bg-cover bg-center md:h-[70vh] text-white p-8 md:px-48"
            style={{ backgroundImage: `url(${WorksBg})` }}
          >
            {/* Image */}
            <img src={SendMoneyImg} alt="Register" className="w-full  max-w-md md:max-w-[14vw]" />

            {/* Content */}
            <div className="md:ml-8 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">Register Free Account</h3>
              <p className="text-lg md:text-xl mb-6 md:w-96">
                Create your new Wire24 account in minutes with just your email.
              </p>
              {/* <button className="bg-[#232323] text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition">
                Start Sending Money
              </button> */}
            </div>
          </div>
          <div
            className="flex flex-col md:flex-row items-center justify-between bg-cover bg-center md:h-[70vh] text-white p-8 md:px-48"
            style={{ backgroundImage: `url(${WorksBg})` }}
          >
            {/* Image */}

            <img src={HomeScreenLeftImg} alt="Register" className="w-full max-w-md md:w-3/4" />
            {/* Content */}
            <div className="md:ml-8 text-center md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">Start Sending Money</h3>
              <p className="text-lg md:text-xl mb-6 md:w-96">
                Send money in all over the world in three steps.
              </p>
              {/* <button className="bg-[#232323] text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition">
                Start Sending Money
              </button> */}
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
};
